import { ReportUploadForm, ReportUploadQueuePanel } from "@/components/patient-tabs/ReportUploadWidget";
import { ReportCategoryFilters } from "@/components/patient-tabs/ReportCategoryFilters";
import { ReportListItem } from "@/components/patient-tabs/ReportListItem";

// The "AI Report Vault" tab — upload widget (staff), processing queue, category
// filters and the report list with expandable AI extraction analysis.
// All data/state is owned by the parent PatientProfileContent.
export default function PatientReportVaultTab({
  isStaff,
  isDoctor,
  uploadCategory,
  setUploadCategory,
  pendingFiles,
  handleFilesSelected,
  isUploading,
  startUpload,
  uploadQueue,
  dismissQueue,
  presentCategories,
  categoryFilter,
  setCategoryFilter,
  filteredReports,
  reports,
  reportAnalyses,
  expandedReportId,
  setExpandedReportId,
  analyzingId,
  runAnalyze,
  viewReport,
  saveParamEdit,
}) {
  return (
    <div className="card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6">
      <h2 className="font-semibold text-slate-900">Report Vault</h2>

      {isStaff && (
        <ReportUploadForm
          uploadCategory={uploadCategory}
          setUploadCategory={setUploadCategory}
          pendingFiles={pendingFiles}
          handleFilesSelected={handleFilesSelected}
          isUploading={isUploading}
          startUpload={startUpload}
        />
      )}

      {uploadQueue.length > 0 && (
        <ReportUploadQueuePanel uploadQueue={uploadQueue} isUploading={isUploading} dismissQueue={dismissQueue} />
      )}

      <ReportCategoryFilters presentCategories={presentCategories} categoryFilter={categoryFilter} setCategoryFilter={setCategoryFilter} />

      <div className="mt-4 space-y-2">
        {filteredReports.map((r) => (
          <ReportListItem
            key={r.id}
            report={r}
            analysis={reportAnalyses[r.id]}
            expanded={expandedReportId === r.id}
            isProcessing={uploadQueue.some((it) => it.reportId === r.id && it.status !== "completed" && it.status !== "failed")}
            setExpandedReportId={setExpandedReportId}
            isDoctor={isDoctor}
            analyzingId={analyzingId}
            runAnalyze={runAnalyze}
            viewReport={viewReport}
            saveParamEdit={saveParamEdit}
          />
        ))}
        {filteredReports.length === 0 && <p className="text-sm text-slate-400">{reports.length === 0 ? "No reports uploaded yet." : "No reports in this category."}</p>}
      </div>
    </div>
  );
}
